import DeviceInfo from 'react-native-device-info';
import { Platform } from 'react-native';

import { firebase } from '@lib/firebase';

const firedEvents = new Map<string, number>();

export const trackEvent = (eventName: string, params = {}) => {
  const sanitizedName = eventName
    .trim()
    .replace(/[^a-zA-Z0-9]+/g, '_')
    .toLowerCase();

  const key = sanitizedName + JSON.stringify(params);
  const now = Date.now();

  if (firedEvents.has(key) && now - firedEvents.get(key)! < 3000) {
    return;
  }

  firedEvents.set(key, now);
  const globalParams = {
    ...params,
    platform: Platform.OS,
    app_version: DeviceInfo.getVersion(),
  };

  firebase.logEvent(sanitizedName, globalParams);
};

/**
 * Use this when a user logs in to identify them across sessions.
 */
export const identifyUser = (userId: string) => {
  firebase.setAnalyticsUserId(userId);
};
